import { useQuery } from '@tanstack/react-query';
import productChangeHistoryService from 'v2/services/ProductChangeHistory';

import type { ChangeHistoryFilter, ChangeHistoryContentItem } from 'v2/interfaces/productChangeHistory';

import type { UseQueryOptions } from '@tanstack/react-query';

type Payload = {
  productId: number;
  filter: ChangeHistoryFilter;
};

export function useProductChangeHistory({ productId, filter }: Payload, options: UseQueryOptions<ChangeHistoryContentItem[]> = {}) {
  return useQuery({
    queryKey: ['product', productId, 'changeHistory'],
    queryFn: () => productChangeHistoryService.getChangeHistory(productId, filter),
    ...options,
  });
}
